<template>
  <teleport to="body">
    <transition name="bottom-sheet-fade">
      <div
        v-if="internalShow"
        class="fixed inset-0 flex flex-col justify-end items-center"
        :style="{ zIndex: zIndex }"
      >
        <!-- Overlay -->
        <div
          class="absolute inset-0 bg-black bg-opacity-40 backdrop-blur-sm transition-opacity"
          @click="handleClose"
        ></div>
        <!-- Sheet -->
        <div
          ref="sheet"
          :class="['relative w-full max-w-md mx-auto bg-white rounded-t-3xl shadow-lg p-0 pb-6 lg:max-w-6xl lg:mt-24', sheetAnimation]"
          
        >
          <slot />
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import Teleport from 'vue2-teleport';
export default {
  name: "BottomSheet",
  props: {
    show: { type: Boolean, default: false },
    zIndex: { type: [Number, String], default: 50 }
  },
  data() {
    return {
      internalShow: this.show,
      sheetAnimation: 'animate-slide-up'
    }
  },
  components: {
    Teleport
  },
  watch: {
    show(val) {
      if (val) {
        this.internalShow = true
        this.sheetAnimation = 'animate-slide-up'
      } else {
        this.triggerSlideDown()
      }
    }
  },
  methods: {
    handleClose() {
      this.triggerSlideDown()
    },
    triggerSlideDown() {
      this.sheetAnimation = 'animate-slide-down'
      setTimeout(() => {
        this.internalShow = false
        this.$emit('close')
      }, 200)
    }
  }
}
</script>

<style scoped>
@keyframes slide-up {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
}
.animate-slide-up {
  animation: slide-up 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}
.animate-slide-down {
  animation: slide-down 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}
.bottom-sheet-fade-enter-active,
.bottom-sheet-fade-leave-active {
  transition: opacity 0.2s;
}
.bottom-sheet-fade-enter,
.bottom-sheet-fade-leave-to {
  opacity: 0;
}
</style>
